export const CLIENT = 'CLIENT';
export const DESIGNER = 'DESIGNER';
export const CONSULTANT = 'CONSULTANT';
export const FABRICATOR = 'FABRICATOR';
export const MAKER_DESIGNER = 'DESIGNER_MAKER';
export const ROLES_HAVING_ACCESS_TO_ECOSYSTEM = [DESIGNER, FABRICATOR, MAKER_DESIGNER, 'MAKER'];